import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './Roulette.css';
import { useTokens } from '../components/TokenContext';

const rouletteNumbers = [
    { number: 0, color: 'green' },
    { number: 1, color: 'red' }, { number: 2, color: 'black' }, { number: 3, color: 'red' },
    { number: 4, color: 'black' }, { number: 5, color: 'red' }, { number: 6, color: 'black' },
    { number: 7, color: 'red' }, { number: 8, color: 'black' }, { number: 9, color: 'red' },
    { number: 10, color: 'black' }, { number: 11, color: 'red' }, { number: 12, color: 'black' },
    { number: 13, color: 'red' }, { number: 14, color: 'black' }, { number: 15, color: 'red' },
    { number: 16, color: 'black' }, { number: 17, color: 'red' }, { number: 18, color: 'black' },
    { number: 19, color: 'red' }, { number: 20, color: 'black' }, { number: 21, color: 'red' },
    { number: 22, color: 'black' }, { number: 23, color: 'red' }, { number: 24, color: 'black' },
    { number: 25, color: 'red' }, { number: 26, color: 'black' }, { number: 27, color: 'red' },
    { number: 28, color: 'black' }, { number: 29, color: 'red' }, { number: 30, color: 'black' },
    { number: 31, color: 'red' }, { number: 32, color: 'black' }, { number: 33, color: 'red' },
    { number: 34, color: 'black' }, { number: 35, color: 'red' }, { number: 36, color: 'black' }
];

function Roulette() {
    const { fetchTokens } = useTokens();
    const [selectedBet, setSelectedBet] = useState(null);
    const [betAmount, setBetAmount] = useState('');
    const [isSpinning, setIsSpinning] = useState(false);
    const [winningNumber, setWinningNumber] = useState(null);
    const [rotationAngle, setRotationAngle] = useState(0);

    const handleNumberClick = (number) => {
        setSelectedBet(number);
    };

    const handleStartGame = async () => {
        if (!selectedBet && selectedBet !== 0) {
            Swal.fire('Chyba', 'Vyber si číslo nebo barvu.', 'warning');
            return;
        }

        if (!betAmount || betAmount <= 0) {
            Swal.fire('Chyba', 'Zadejte platnou sázku.', 'warning');
            return;
        }

        const userId = localStorage.getItem('fw_user');

        if (!userId) {
            Swal.fire('Chyba', 'Uživatel není přihlášen.', 'error');
            return;
        }

        setIsSpinning(true);

        try {
            const response = await fetch('https://api.fantasyworldtrpg.cz/casino-api/roulette.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    user_id: userId,
                    bet: selectedBet,
                    amount: betAmount
                })
            });

            const data = await response.json();

            const randomAngle = 360 * 5 + (data.winningNumber * (360 / 37));
            setRotationAngle(randomAngle);

            setTimeout(() => {
                setIsSpinning(false);
                setWinningNumber(data.winningNumber);

                if (data.error) {
                    Swal.fire('Chyba', data.error, 'error');
                    return;
                }

                if (data.win) {
                    Swal.fire('Výhra!', `Vyhrál jsi ${data.payout.toLocaleString('cs-CZ')} tokenů! 🎉`, 'success');
                }
                fetchTokens()
            }, 3000);
        } catch (error) {
            setIsSpinning(false);
            Swal.fire('Chyba', 'Nepodařilo se spojit se serverem.', 'error');
        }
    };

    return (
        <div className="game-roulette">
            <h1>Ruleta 🎯</h1>

            {winningNumber !== null && (
                <div className="winning-number">
                    Výherní číslo: <strong>{winningNumber}</strong>
                </div>
            )}

            <div className="roulette-container">
                <div className="roulette-wheel" style={{ transform: `rotate(${rotationAngle}deg)` }}>
                    <div className="pointer">▼</div>
                </div>

                <div className="roulette-table">
                    {rouletteNumbers.map(({ number, color }) => (
                        <div
                            key={number}
                            className={`roulette-number ${color} ${selectedBet === number ? 'selected' : ''}`}
                            onClick={() => handleNumberClick(number)}
                        >
                            {number}
                        </div>
                    ))}
                </div>
            </div>

            <div className="input-container">
                <input
                    type="number"
                    min="1"
                    value={betAmount}
                    onChange={(e) => setBetAmount(e.target.value)}
                    placeholder="Zadej sázku"
                />
                <button className="btn btn-warning" onClick={handleStartGame} disabled={isSpinning}>
                    {isSpinning ? 'Točí se...' : 'Roztočit ruletu'}
                </button>
            </div>
        </div>
    );
}

export default Roulette;
